module.exports = __webpack_public_path__ + "static/img/MQ@2x.62e72b79.jpg";